import React from 'react';
import './button.css'

function Button(props){
  return <a className={'button ' + props.className} href={props.linkHref}>{props.linkTitle}</a>
}

export default Button;